import { types as actionTypes } from './waiverWorkItemUpdateStatusActions';
import { Action } from '../../../types';
import { EventStatus } from '../../../../types/components';

export type WaiverWorkItemUpdateStatus = EventStatus & {
  statusMessage?: {
    success: boolean;
    message: string;
  };
};

const initialState: WaiverWorkItemUpdateStatus = {
  pending: false,
};

export default function reducer(
  state: WaiverWorkItemUpdateStatus = initialState,
  action: Action<string>
): WaiverWorkItemUpdateStatus {
  switch (action.type) {
    case actionTypes.CHANGE_SUCCESS:
      return {
        pending: false,
        statusMessage: {
          success: true,
          message: action.response || 'No response message',
        },
      };
    case actionTypes.CHANGE_FAIL:
      return {
        pending: false,
        statusMessage: {
          success: false,
          message: action.error?.message || 'Unknown Error',
        },
      };
    case actionTypes.CHANGE:
      return {
        pending: true,
      };
    case actionTypes.RESET:
      return {
        pending: false,
      };
    default:
      return state;
  }
}
